import React, { useState } from "react";
import { Link } from "react-router-dom";
import Admissionleft from "./Admissoinleft";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import Fade from "react-bootstrap/Fade";

function MtechSpot_AdmissionELe() {
    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    // const [categoryOpen, setCategoryOpen] = useState(false);
    const [areasOpen, setAreasOpen] = useState(false);
    const [seatsOpen, setSeatsOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    // const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        // setCategoryOpen(false);
        setAreasOpen(false);
        setSeatsOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        // setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    };

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className="c-left custom-padding-color mb-5">
                        <Admissionleft activeIndex={2} />
                    </Col>

                    <Col md={8} className="c-right">
                        <div className="c-heading">
                            <h3>Master of Technology - Spot Round of Admissions</h3> <br />
                        </div>

                        <Row className="mb-5">
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button"
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}
                                >
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setGuidelinesOpen)
                                    }
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}
                                >
                                    Guidelines
                                </Button>
                            </Col>

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}
                                >
                                    Categories
                                </Button>
                            </Col> */}

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}
                                >
                                    Areas
                                </Button>
                            </Col>
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setSeatsOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={seatsOpen}
                                >
                                    Available Seats
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setEligiblityOpen)
                                    }
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}
                                >
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setFinancialOpen)
                                    }
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}
                                >
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}
                                >
                                    Selection
                                </Button>
                            </Col> */}
                            {/* Documents */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setDocumentsOpen)
                                    }
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}
                                >
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}
                                >
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setApplyonlineOpen)
                                    }
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}
                                >
                                    Apply Online
                                </Button>
                            </Col>
                        </Row>

                        {/*dates */}
                        <div>
                            {datesOpen && (
                                <Fade in={datesOpen}>
                                    <div>
                                    {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for M.Tech on July 26, 2024 - {" "}
                                    <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_Mtech_Msc_MPP_2024.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p>

                                         <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" /> 
                                         <a className='text-maroon' href="https://files.iittp.ac.in/pdfs/msphd/admissions/2024/IITTP_2024-25_M.TechSponsored.pdf" target="_blank;"><b>Selected Candidates List for M.Tech program under the Sponsored Category - Click here</b></a>  */}
                                        <p className="caboutus">
                                        Online applications are invited from eligible candidates for spot admission into the various M.Tech programs. The details about the available seats, eligibility, documents to upload and the other guidelines are provided below. 
                                        </p>

                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h4 className="text-primary">
                                                        Important Dates for Spot Round Admissions
                                                        </h4>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                    Opening date for online application for spot rounds
                                                    </td>
                                                    <td>
                                                    <b>Will be updated soon</b>
                                                        {/* <b>Wednesday, March 20, 2024 at 10 AM</b> */}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Closing date for online application for spot rounds
                                                    </td>
                                                    <td>
                                                    <b>Will be updated soon</b>
                                                        {/* <b>	Friday, April 19, 2024 upto 5 PM</b> */}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <td>COAP Rounds</td>
                                                    <td>
                                                        <a href="https://iitk.ac.in/coap2024/important-dates" target="_blank;"><u><b>https://iitk.ac.in/coap2024/important-dates</b></u></a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Orientation Program</td>
                                                    <td>
                                                        <b>Friday, July 26, 2024</b>
                                                    </td>
                                                </tr> */}
                                                <tr>
                                                    <td>
                                                    Last date for reporting
                                                    </td>
                                                    <td>
                                                    <b>Will be updated soon</b>
                                                        {/* <b>Thursday, August 1, 2024</b> */}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>

                                        <b>
                                            Please write to{" "}
                                            <Link
                                                to="mailto:admissions@iittp.ac.in"
                                                className="c-link"
                                            >
                                                admissions@iittp.ac.in
                                            </Link>{" "}
                                            for any questions or queries
                                            regarding admission related matters.{" "}
                                        </b>
                                        <p></p>
                                        <p className="fw-bold caboutus"> <span className="glowing-text">Candidates offered with the admission through Spot Round will be communicated through Email. Please do not report to the campus if you do not receive the Email.</span></p>

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && (
                                <Fade in={guidelinesOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Important Guidelines
                                        </h4>
                                        <h5>For Half-Time Teaching Assistantship (HTTA) Candidates</h5>
                                        <p>Candidates admitted under this category will get financial assistance in the form of Half-Time Teaching Assistantship (HTTA), as per applicable norms.</p>
                                        <ol className="list-group list-group-numbered"
                                            style={{
                                                textAlign: "justify",
                                                fontSize: "12pt",
                                            }}
                                        >
                                            <li>
                                                {" "}
                                                COAP registration is mandatory
                                                for{" "}
                                                <ul className="myulcustarrow">
                                                    {" "}
                                                    <li>
                                                    a. Candidates having a B.Tech. degree from an IIT with a CGPA less than 8.0 on a 10-point scale (7.5 CGPA for SC/ST).
                                                    </li>{" "}
                                                    <li>
                                                    b. Candidates having a Bachelor's degree in Engineering/Technology or Master's degree in Science from any Institute/University other than an IIT.
                                                    </li>
                                                </ul>{" "}
                                                To register in the CoAP portal,
                                                please visit{" "}
                                                <a className="c-link"
                                                    href="https://iitk.ac.in/coap2024/"
                                                    target="_blank;"
                                                >
                                                    https://iitk.ac.in/coap2024/
                                                </a>

                                            </li>
                                            <li>
                                            The link to the online application form is available in the Apply Online tab. After filling out the form, please take a print and keep it for your record.
                                            </li>

                                            <li>
                                            Within an application, candidates can apply for more than one stream. However, A candidate has to enter the streams in his/her order of preference if he/she wish to apply for more than one stream. The order of the preference entered by the candidate will be considered for seat allotment.
                                            </li>

                                            <li>
                                                {" "}
                                                The application fee is as follows:
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Male candidates : Rs.400/-{" "}
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Female candidates : Rs.200/-
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        SC/ST and PwD candidates : Rs.200/-
                                                    </li>
                                                </ul>
                                                <em
                                                    style={{ color: "#2009df" }}
                                                >
                                                    The application fee is non-refundable. Please ensure to save the payment reference number.
                                                </em>
                                            </li>



                                            <li>
                                            Seats are reserved for Indian Nationals under the categories, SC/ST/ EWS/ OBC-NCL and PwD (Persons with Disability) according to the Government of India norms.
                                            </li>

                                            <li>
                                                {" "}
                                                A copy of valid EWS/OBC-NCL/SC/ST/PwD certificate must be uploaded at the time of ONLINE application and must be submitted at the time of verification and admission.
                                            </li>

                                            <li>
                                                {" "}
                                                Please make all files ready with following format and size before going to file upload: 
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        Passport size Photo
                                                        (jpg, jpeg, png), size
                                                        &lt;=500 KB
                                                    </li>
                                                    <li>
                                                        Signature (format jpg,
                                                        jpeg, png) size &lt;=
                                                        200 KB
                                                    </li>
                                                    <li>
                                                        10th Certificate (pdf)
                                                        size &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        12th / Diploma /
                                                        Equivalent Certificate
                                                        (pdf) size &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        Qualifying UG Degree
                                                        Certificate (pdf) size
                                                        &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        Consolidated UG mark
                                                        sheet (pdf) size
                                                        &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        Community Certificate if
                                                        applicable (pdf) size
                                                        &lt;= 1024 KB
                                                    </li>
                                                    <li>
                                                        PwD Certificate if
                                                        applicable (pdf) size
                                                        &lt;= 1024 KB
                                                    </li>
                                                </ul>
                                            </li>
                                        </ol>


                                        <ol className="list-group list-group-numbered"
                                            style={{
                                                textAlign: "justify",
                                                fontSize: "12pt",
                                            }}
                                        >
                                            <h5 className="mb-3">For Sponsored candidates (Non-HTTA)</h5>
                                            <p className="mb-3">Candidates admitted under the Non-HTTA category will not get any financial assistance from the Institute and cannot be moved to the HTTA category at a later date.</p>
                                            <li>
                                            The link to the online application form is available in the Apply Online tab.
                                            </li>

                                            <li>
                                                {" "}
                                                The application fee is as
                                                follows:
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Male candidates : Rs.400/-{" "}
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Female candidates : Rs.200/-
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        SC/ST and PwD candidates : Rs.200/-
                                                    </li>
                                                </ul>
                                                <em
                                                    style={{ color: "#2009df" }}
                                                >
                                                   The application fee is non-refundable. Please ensure to save the payment reference number.
                                                </em>
                                            </li>



                                            <li>
                                            If a candidate wishes to apply for more than one stream, a separate application needs to be filled and separate payment has to be made for each stream separately.
                                            </li>


                                            <li>
                                                {" "}
                                                Please make all files ready with following format and size before going to file upload: 
                                                <ul className="myulcustarrow">

                                                    <li> Passport size Photo (jpg, jpeg, png) </li>
                                                    <li> Signature (format jpg, jpeg, png)  </li>
                                                    <li> 10th Certificate (pdf) </li>
                                                    <li> 12th / Diploma / Equivalent Certificate (pdf) </li>
                                                    <li> Essential Qualifying Degree Certificate (pdf) </li>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf)  </li>
                                                    <li> No-Objection Certificate or Undertaking (pdf)  </li>
                                                    <li> Sponsorship certificate from the current organization (pdf)  </li>
                                                    <li> GATE scorecard, if applicable (pdf) </li>
                                                    <li> Associate membership certificate, if applicable (pdf) </li>
                                                    <li> Community Certificate if applicable (pdf) </li>
                                                    <li> PwD Certificate if applicable (pdf) </li>


                                                </ul>
                                            </li>
                                        </ol>

                                        <li>
                                            {" "}
                                            Please visit the institute’s website regularly for important announcements and results.
                                        </li>
                                        <li>
                                            In case of any queries, please
                                            write to{" "}
                                            <a className="c-link" href="mailto:admissions@iittp.ac.in">
                                                admissions@iittp.ac.in
                                            </a>{" "}
                                            or call 0877 250 3532 (9.00 AM to
                                            5.30 PM on all working days).
                                        </li>

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Categoies*/}

                        {/* <div>
                            {categoryOpen && (
                                <Fade in={categoryOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Ph.D admissions are made under two
                                            categories
                                        </h4>

                                        <li>
                                            1. Regular (Full-time scholars): The
                                            research scholars selected under
                                            regular registration will be
                                            eligible for assistantship through
                                            various schemes (please see
                                            Financial Assistance)
                                        </li>
                                        <li>
                                            External:
                                            <ul className="myulcustarrow">
                                                <li>
                                                    The applicants must be
                                                    regular employees and have
                                                    at least two years of work
                                                    experience.
                                                </li>
                                                <li>
                                                    They must be sponsored by
                                                    and employed in an
                                                    industry/organization/national
                                                    laboratories, having R&D
                                                    facilities and recognized by
                                                    DST or by IIT Tirupati.
                                                </li>
                                                <li>
                                                    Research scholars admitted
                                                    under this category will
                                                    normally carry out part or
                                                    all of their research in the
                                                    parent organization under
                                                    supervision of a faculty
                                                    from IIT Tirupati and a
                                                    co-supervisor employed in
                                                    their parent organization.
                                                </li>
                                            </ul>
                                        </li>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required along with the
                                                application{" "}
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Proof of employment (Identity
                                                Card or latest salary statement)
                                            </li>
                                            <li>
                                                No-Objection Certificate or
                                                Undertaking (format available at
                                                this{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/3.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                                )
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required at the time of
                                                admission
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Certificate of Support from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/4.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                            <li>
                                                Relieving Certificate from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/5.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                More details on this category of
                                                admission, including any
                                                questions regarding the
                                                recognition of the
                                                organization/laboratory might be
                                                addressed to the Head of the
                                                department of interest or{" "}
                                                <Link
                                                    to="mailto:admissions@iittp.ac.in"
                                                    className="c-link"
                                                >
                                                    admissions@iittp.ac.in
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Areas*/}

                        <div>
                            {areasOpen && (
                                <Fade in={areasOpen}>
                                    <div>
                                        <h4 className="mb-4">Areas</h4>
                                        <p>
                                        IIT Tirupati offers M.Tech. programs in the following areas/streams.
                                        </p>

                                        {/* Table */}
                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3 c-table"
                                        >
                                            <colgroup>
                                                {/* <col style={{ width: "20%" }} />{" "} */}
                                                {/* 33% for each column */}
                                                <col style={{ width: "50%" }} />
                                                <col style={{ width: "50%" }} />
                                            </colgroup>
                                            <tbody>
                                                {/* Table header */}
                                                <tr>
                                                    <td>
                                                        <b>Department</b>
                                                    </td>
                                                    <td>
                                                        <b>
                                                            M.Tech. Stream /
                                                            Specialization
                                                        </b>
                                                    </td>
                                                </tr>
                                                {/* Table rows */}
                                                {/* Row 1 */}
                                                <tr>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                </tr>
                                                {/* Row 2 */}
                                                <tr>
                                                    <td rowspan="4" valign="middle">
                                                        Civil and Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Environmental and Water
                                                        Resources Engineering
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>
                                                        Geotechnical Engineering
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Structural Engineering
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Transportation and
                                                        Infrastructure
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 3 */}
                                                <tr>
                                                    <td>
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 4 */}
                                                <tr>
                                                    <td rowspan="3" valign="middle">
                                                        Electrical Engineering
                                                    </td>
                                                    <td>
                                                        Signal Processing &
                                                        Communications
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Microelectronics & VLSI
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        RF & Microwave
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 5 */}
                                                <tr>
                                                    <td rowspan="2" valign="middle">
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        Design & Manufacturing
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Thermal Engineering and
                                                        Energy systems
                                                    </td>
                                                </tr>

                                                {/* End of table rows */}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Available Seats*/}

                        <div>
                            {seatsOpen && (
                                <Fade in={seatsOpen}>
                                    <div>
                                        <h4 className="mb-4">Available Seats</h4>
                                        {/* <p>
                                        IIT Tirupati offers M.Tech. programs in the following areas/streams.
                                        </p> */}

                                        {/* Table */}
                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3 c-table"
                                        >
                                            <colgroup>
                                                {/* <col style={{ width: "20%" }} />{" "} */}
                                                {/* 33% for each column */}
                                                <col style={{ width: "50%" }} />
                                                <col style={{ width: "50%" }} />
                                            </colgroup>
                                            <tbody>
                                                {/* Table header */}
                                                <tr>
                                                    <td>
                                                        <b>Department</b>
                                                    </td>
                                                    <td>
                                                        <b>
                                                            M.Tech. Stream /
                                                            Specialization
                                                        </b>
                                                    </td>
                                                </tr>
                                                {/* Table rows */}
                                                {/* Row 1 */}
                                                <tr>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                </tr>
                                                {/* Row 2 */}
                                                <tr>
                                                    <td rowspan="4" valign="middle">
                                                        Civil and Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Environmental and Water
                                                        Resources Engineering
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>
                                                        Geotechnical Engineering
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Structural Engineering
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Transportation and
                                                        Infrastructure
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 3 */}
                                                <tr>
                                                    <td>
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 4 */}
                                                <tr>
                                                    <td rowspan="3" valign="middle">
                                                        Electrical Engineering
                                                    </td>
                                                    <td>
                                                        Signal Processing &
                                                        Communications
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Microelectronics & VLSI
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        RF & Microwave
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 5 */}
                                                <tr>
                                                    <td rowspan="2" valign="middle">
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        Design & Manufacturing
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Thermal Engineering and
                                                        Energy systems
                                                    </td>
                                                </tr>

                                                {/* End of table rows */}
                                            </tbody>
                                        </Table><br/>
                                        <p class="fontSize: 9px;">**Note: The vacancies shown above are as of 5 pm on 24.07.2024</p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && (
                                <Fade in={eligiblityOpen}>
                                    <div>
                                        <h4 className="mb-4">Eligibility</h4>
                                        <p>Candidates seeking admission to the M.Tech. programme are required to meet the following criteria:</p>

                                        <h5 className="mb-4">For Half-Time Teaching Assistantship (HTTA) candidates</h5>

                                        <h5 className="mb-4">(A) For GATE qualified candidates</h5>

                                        <ul className='myulcustarrow'>
                                            <li>
                                            Bachelor’s degree in Engineering/ Technology or Master’s Degree in a suitable discipline as in the below table (Table A) from Educational Institutions approved by AICTE/ Government.
                                            </li>
                                            <li>
                                            Candidates must have qualified in GATE 2024, 2023 or 2022 in a suitable GATE paper as in the below table (Table A).
                                            </li>
                                            <li>
                                            Candidates yet to appear or have appeared in the final examination for the qualifying degree specified as specified below and whose are likely to complete the requirements for qualifying degree July, 2024.
                                            </li>
                                        </ul>

                                        <h5 className="mb-4">(B) For IIT Graduates</h5>
                                        <p>Candidates with B.Tech degree from IITs who satisfy the following conditions can apply without a valid GATE score. </p>
                                        <ul className='myulcustarrow'>
                                            <li>
                                            Candidates graduating/ graduated from IITs with B.Tech. degree in a suitable discipline as in the below table (Table A). 
                                            </li>
                                            <li>
                                            Candidates must have CGPA of 8.0 (7.5 for SC/ST) on a scale of 10.0 and above in the B.Tech. degree.
                                            </li>

                                        </ul>
                                        <Link to="/m-tech-admission#brochure" target="_blank" className="c-link" >
                                        Candidates seeking M.Tech admission under Half-Time Teaching Assistantship (HTTA) category can apply online by clicking the link given for GATE qualified/ IIT Graduates ( HTTA candidates) in Apply online Tab.
                                        </Link>


                                        <h4 className="mb-4 mt-4">For Non-HTTA candidates</h4>
                                        <h5 className="mb-4 mt-4">(A) Sponsored candidates</h5>
                                        <p>Candidates sponsored (with full pay and allowances for 24 months) by and employed in an industry/organization/national laboratories recognized by DST or by IIT Tirupati, possessing at least two years of professional experience as on the last date of receipt of applications at IIT Tirupati can apply, provided they hold one of the following:</p>
                                        <ul className='myulcustarrow'>
                                            <li>
                                            B.E/ B.Tech. or Master's degree in science in a suitable discipline as in the below table (Table A), having 60% aggregate marks in all the years of eligible degree.
                                            </li>
                                            <li>
                                            B.E/ B.Tech. or master’s degree in science in a suitable discipline as in the below table (Table A), with Valid GATE Score in a suitable discipline as in the below table (Table A).
                                            </li>
                                            <li>
                                            Associate Membership holders of professional bodies (such as AMIE, AESI, AMIM, AMIIChemE, AMIETE) for Admission into their parent disciplines.
                                            </li>

                                        </ul>

                                        <Link to="/m-tech-admission#brochure" target="_blank" className="c-link" >
                                        Candidates seeking M.Tech admission under sponsored scheme (Non-HTTA category) can apply online by clicking the link given for Sponsored (Non-HTTA candidates) in Apply online Tab.
                                        </Link>

                                        <h5 className="text-teal m-4 mb-4">Candidates seeking admission to the M.Tech. programme in different streams are required to meet the minimum eligibility criteria regarding their educational qualifications and any additional qualifying exams, as outlined in the following table.</h5>
                                        <h5 className="text-center"><u>Table A</u></h5>
                                        <table bordered
                                            responsive
                                            className="mt-3 c-table">
                                            <thead>
                                                <tr>
                                                    <th colspan="4" ><b>Eligibility to apply for M. Tech programme - 2024</b></th>
                                                </tr>
                                                <tr>
                                                    <th colspan="2" ><b>A candidate is eligible to apply for M.Tech at IIT Tirupati in </b></th>
                                                    <th rowspan="2" ><b>If the candidate has</b></th>
                                                    <th rowspan="2" ><b>and if the candidate has qualified GATE PAPER in</b></th>
                                                </tr>
                                                <tr>
                                                    <th ><b>Department</b></th>
                                                    <th ><b>Stream</b></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td rowspan="2" >Chemical Engineering</td>
                                                    <td rowspan="2">Chemical Engineering</td>
                                                    <td>B.E/B.Tech in any Engineering Branch</td>
                                                    <td>CH (Chemical Engineering) (or) BT (Bio-Technology) (or) ES ( Environmental Science & Engineering) (or) MT (Metallurgical Engineering) </td>
                                                </tr>

                                                <tr>

                                                    <td class="text-left">B.E/B.Tech in Chemical Engineering</td>
                                                    <td class="text-left">Any GATE paper</td>
                                                </tr>

                                                <tr>
                                                    <td rowspan="5" >Civil and Environmental Engineering</td>
                                                    <td rowspan="2" >Environmental and Water Resources Engineering</td>
                                                    <td class="text-left">(i) B.E./ B.Tech in Agricultural Engineering (or) Biotechnology (or) Chemical Engineering (or) Civil Engineering (or) Energy Engineering (or) Environmental Engineering </td>
                                                    <td class="text-left">AG (Agricultural Engineering) (or) BT (Bio-Technology) (or) CH (Chemical Engineering) (or) CE (Civil Engineering) (or) ES (Environmental Science and Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-left">(ii) M.Sc. in Atmospheric Science (or) Chemistry (or) Environmental Science <br />
                                                        <p className="text-teal mt-3 mb-3">(Candidates with M.Sc as an eligible degree for Environmental and Water Resource Engineering, requirement of Mathematics subject is essential in at least one of (10 + 2) /UG/ PG level.)</p>
                                                    </td>
                                                    <td class="text-left">CY (Chemistry) (or) ES (Environmental Science and Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td >Geotechnical Engineering</td>
                                                    <td class="text-left">B.E./ B.Tech in Civil Engineering</td>
                                                    <td class="text-left">CE (Civil Engineering) (or) ES (Environmental Science and Engineering) (or) MN (Mining Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td >Structural Engineering</td>
                                                    <td class="text-left">B.E./ B.Tech in Civil Engineering</td>
                                                    <td class="text-left">CE (Civil Engineering) (or) AE (Aerospace Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td >Transportation and Infrastructure Engineering</td>
                                                    <td class="text-left">B.E./ B.Tech in Civil Engineering</td>
                                                    <td class="text-left">CE (Civil Engineering) (or) ES (Environmental Science and Engineering) (or) MT (Metallurgical Engineering) (or) MN (Mining Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td >Computer Science & Engineering</td>
                                                    <td >Computer Science & Engineering</td>
                                                    <td class="text-left">B.E/ B.Tech/M.Sc/MCA/MS degree in any discipline</td>
                                                    <td class="text-left">CS (Computer Science and Information Technology) (or) DA (Data Science & Artificial Intelligence)</td>
                                                </tr>
                                                <tr>
                                                    <td rowspan="3" >Electrical Engineering</td>
                                                    <td >Microelectronics & VLSI</td>
                                                    <td rowspan="3" class="text-left">BE/B.Tech degree in Electrical Engineering (or) Electronics and Communication Engineering (or) Electrical and Electronics Engineering (or) Computer and Communication Engineering (or) Biomedical Engineering (or) Electronics and Instrumentation Engineering (or) Electronics and Telecommunication Engineering (or) Electronics Engineering (VLSI Design and Technology) (or) Electronics Communication (Advanced Communication Technology) (or) Electronics and Computer Engineering (or) M.Sc in Electronics (or) Electronics and Telecommunications (or) Electronics and Communication Engineering (or) Physics</td>
                                                    <td class="text-left">EC (Electronics and Communication Engineering) (or) EE (Electrical Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td >RF and Microwave Engineering</td>
                                                    <td class="text-left">EC (Electronics and Communication Engineering) (or) EE (Electrical Engineering) (or) IN (Instrumentation Engineering) (or) PH (Physics)</td>
                                                </tr>
                                                <tr>
                                                    <td >Signal Processing & Communications</td>
                                                    <td class="text-left">EC (Electronics and Communication Engineering) (or) EE (Electrical Engineering) (or) IN (Instrumentation Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td rowspan="2" >Mechanical Engineering</td>
                                                    <td >Design & Manufacturing</td>
                                                    <td class="text-left">BE/ B.Tech degree in Mechanical Engineering (or) Production Engineering/ Industrial and Production Engineering (or) Metallurgical and Materials Engineering</td>
                                                    <td class="text-left">ME (Mechanical Engineering) (or) PI (Production and Industrial Engineering) (or) MT (Metallurgical Engineering)</td>
                                                </tr>
                                                <tr>
                                                    <td >Thermal Engineering and Energy Systems</td>
                                                    <td class="text-left">BE/ B.Tech degree in Mechanical Engineering (or) Aerospace engineering</td>
                                                    <td class="text-left">ME (Mechanical Engineering) (or) AE (Aerospace Engineering)</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td rowSpan="2">
                                                        If you have
                                                    </td>
                                                    <td rowSpan="2">
                                                        <b>
                                                            And if you have
                                                            written GATE PAPER
                                                            in
                                                        </b>
                                                    </td>
                                                    <td colSpan="2">
                                                        <b>
                                                            You are eligible to
                                                            apply for M. Tech in
                                                        </b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Department</td>
                                                    <td>
                                                        Stream/Specialization
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in any
                                                        discipline
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Chemical
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="2" valign="middle">
                                                        BE/B. Tech degree in
                                                        Civil
                                                        Engineering/Environmental
                                                        Science/Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Civil Engineering /
                                                        Environmental Science
                                                        and Engineering
                                                    </td>
                                                    <td>
                                                        Civil & Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Environmental
                                                                and Water
                                                                Resources
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Civil Engineering</td>
                                                    <td>
                                                        Civil & Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Geotechnical
                                                                Engineering
                                                            </li>
                                                            <li>
                                                                Structural
                                                                Engineering
                                                            </li>
                                                            <li>
                                                                Transportation
                                                                and
                                                                Infrastructure
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in any
                                                        discipline
                                                    </td>
                                                    <td>
                                                        Computer Science and
                                                        Information Technology
                                                    </td>
                                                    <td>
                                                        Computer Science and
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Computer Science
                                                                and Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in
                                                        Electrical
                                                        Engineering/Electronics
                                                        and Communication
                                                        Engineering/Electrical
                                                        and Electronics
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Electronics and
                                                        Communication
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Electrical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Signal
                                                                Processing and
                                                                Communications
                                                            </li>
                                                            <li>
                                                                Microelectronics
                                                                and VLSI
                                                            </li>
                                                            <li>
                                                                RF and Microwave
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in
                                                        Mechanical
                                                        Engineering/Production
                                                        Engineering/Industrial
                                                        and Production
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical
                                                        Engineering/Production
                                                        and Industrial
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Design and
                                                                Manufacturing
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in
                                                        Mechanical
                                                        Engineering/Aerospace
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical
                                                        Engineering/Aerospace
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Thermal
                                                                Engineering and
                                                                Energy systems
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table> */}
                                        {/* <p>
                                            <b>For GATE qualified candidates</b>
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Bachelor’s degree in
                                                Engineering/Technology in a
                                                suitable discipline as in the
                                                above table from Educational
                                                Institutions approved by
                                                AICTE/Government.
                                            </li>
                                            <li>
                                                Candidates must have qualified
                                                in GATE 2023, 2022, or 2021 in a
                                                suitable GATE paper as in the
                                                above table.
                                            </li>
                                            <li>
                                                Candidates yet to appear or have
                                                appeared in the final
                                                examination for the qualifying
                                                degree specified as specified
                                                above and who are likely to
                                                complete the requirements for
                                                the qualifying degree by July
                                                2023.
                                            </li>
                                        </ul>
                                        <p>
                                            <b>For IIT Graduates</b>
                                        </p>
                                        <p>
                                            Candidates with B.Tech degree from
                                            IITs who satisfy the following
                                            conditions can apply without a valid
                                            GATE score.
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Candidates graduating/graduated
                                                from IITs with B.Tech. degree in
                                                a suitable discipline as in the
                                                above table.
                                            </li>
                                            <li>
                                                Candidates must have CGPA of 8.0
                                                (7.5 for SC/ST) and above in the
                                                B.Tech. degree.
                                            </li>
                                        </ul> */}
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && (
                                <Fade in={financialOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Financial Assistance
                                        </h4>
                                        <p>
                                        Financial assistance in the form of Half-Time Teaching Assistantship (HTTA) at the rate of Rs.12,400/- p.m. (tenable for a maximum period of 24 months) will be awarded to Indian Nationals pursuing the M. Tech. Programmes, subject to Institute rules. Students receiving HTTA are required to assist for 8 hours/week in the academic activities of the department such as laboratory demonstration, tutorials, evaluation of assignments, test papers, seminars, research projects etc.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        {/* <div>
                            {sectionOpen && (
                                <Fade in={sectionOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Selection Procedure
                                        </h4>
                                        <p>
                                            The selection committee will call
                                            eligible candidates based on the
                                            minimum eligibility requirements and
                                            additional screening criteria for a
                                            written test (if any) and interview.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Documents*/}

                        <div>
                            {documentsOpen && (
                                <Fade in={documentsOpen}>
                                    <div>
                                    <h3 className="mb-4"> For Half-Time Teaching Assistantship (HTTA) Candidates:</h3>
                                        <h4 className="mb-4">
                                            Original Documents to be submitted for Verification:
                                        </h4>
                                        <p>
                                            <b>At the time of admission:</b>
                                        </p>
                                        <p>
                                        Self-attested copies of the following documents must be submitted at the time of admission. 
                                        </p>

                                        <ul className="myulcustarrow">
                                            <li>Copy of application</li>
                                            <li>Offer of admission.</li>
                                            <li>
                                            Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
                                            </li>
                                            <li>
                                            Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc. {" "}
                                            </li>
                                            <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                            </li>
                                            <li>
                                            Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                            </li>
                                            <li>
                                            Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                            </li>
                                            <li>
                                            Copy of valid GATE score (if applicable).
                                            </li>
                                        </ul>
                                        <h5 className="text-teal">
                                        Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                        </h5>


                                        <h4 className="mb-5 mt-5">For Sponsored candidates (Non-HTTA)Candidates: </h4>
                                        <ul className="myulcustarrow">
                                            <li> Offer of admission.</li>
                                            <li> 10th Certificate</li>
                                            <li> 12th / Diploma / Equivalent Certificate </li>
                                            <li> Essential Qualifying Degree Certificate</li>
                                            <li> GATE scorecard, if applicable</li>
                                            <li> Associate membership certificate, if applicable </li>
                                            <li> Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.</li>
                                            <li> Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.</li>
                                        </ul>

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        <div>
                            {feesOpen && (
                                <Fade in={feesOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Fees and Deposits
                                        </h4>
                                        <p>
                                        The applicable tuition and other fee / deposits for M.Tech students is available at the following{" "}
                                            <Link
                                                to="/fee-structure"
                                                className="c-link"
                                            >
                                                link
                                            </Link>
                                            .
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>
                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && (
                                <Fade in={applyonlineOpen}>
                                    <div>
                                        {/* <h5 className="mb-4">Apply Online : 
                                      

                                            <Link
                                                to="https://iittp.plumerp.co.in/prod/iittirupati/mtechapplication"
                                                target="_blank"
                                                className="c-link">
                                                <b className="text-maroon">Click here to apply</b>
                                            </Link>

                                        </h5> */}

                                        <h5 className="mb-4">For GATE qualified/IIT Graduates (HTTA candidates) :


                                            <Link to="#" className="c-link">
                                                <b className="text-maroon">Online applications are now closed.</b>
                                            </Link><br /><br />
                                            <Link to="https://iittp.plumerp.co.in/prod/iittirupati/mtechapplication"  target="_blank" className="c-link">
                                                <b className="text-maroon">Click here to login and download application</b>
                                            </Link>

                                        </h5> 

                                        <h5 className="mb-4">For Sponsored (Non-HTTA candidates)  :


                                        <Link to="#"  className="c-link">
                                                <b className="text-maroon">Online applications are now closed.</b>
                                            </Link>

                                        </h5> 

                                        

                                    
                                    </div>
                                </Fade>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default MtechSpot_AdmissionELe;
